
namespace RioERP.Reports {

    @Serenity.Decorators.registerClass()
    export class InvoiceBillingItemsReportGrid extends Serenity.EntityGrid<InvoiceBillingItemsReportRow, any> {
        protected getColumnsKey() { return InvoiceBillingItemsReportColumns.columnsKey; }
        protected getDialogType() { return InvoiceBillingItemsReportDialog; }
        protected getIdProperty() { return InvoiceBillingItemsReportRow.idProperty; }
        protected getInsertPermission() { return InvoiceBillingItemsReportRow.insertPermission; }
        protected getLocalTextPrefix() { return InvoiceBillingItemsReportRow.localTextPrefix; }
        protected getService() { return InvoiceBillingItemsReportService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();
            buttons.splice(1, 3);

            buttons.push(Common.ExcelExportHelper.createToolButton({
                grid: this,
                title: 'Export',
                service: InvoiceBillingItemsReportService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons;
        }

        protected getQuickFilters() {
            var filter = super.getQuickFilters();
            if (Authorization.hasPermission("Users:Franchisee") && !Authorization.hasPermission("Administration:Security")) {
                filter.splice(0, 2);
            }
            return filter;
        }
    }
}